// components/RequireAuth.jsx
import { Navigate, useLocation } from 'react-router-dom';

export default function RequireAuth({ isAuth, children }) {
    const location = useLocation();

    if (!isAuth) {
        localStorage.setItem(
            'redirectAfterLogin',
            location.pathname + location.search
        );
        return <Navigate to="/login" replace />;
    }

    return children;
}